import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Sparkles } from "lucide-react";
import { waLink } from "../data/content";
import { EASE } from "./Reveal";

export const EnrollmentPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("enrollDismissed")) return;
    const t = setTimeout(() => setShow(true), 6000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem("enrollDismissed", "1");
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.96 }}
          transition={{ duration: 0.6, ease: EASE }}
          data-testid="enrollment-popup"
          className="fixed bottom-6 left-6 z-50 w-[calc(100%-3rem)] max-w-[330px] rounded-3xl bg-[#21070D] border border-[#CBA135]/35 shadow-[0_24px_70px_-20px_rgba(0,0,0,0.7)] overflow-hidden"
        >
          <div className="grain relative p-6">
            <button
              onClick={dismiss}
              data-testid="enrollment-popup-close"
              aria-label="Close"
              className="absolute top-4 right-4 grid place-items-center h-8 w-8 rounded-full bg-[#F4EBD9]/10 text-[#F4EBD9] hover:bg-[#F4EBD9]/20 transition-colors"
            >
              <X size={16} />
            </button>

            <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#EBD08A]">
              <Sparkles size={13} /> Enrolment Open
            </span>
            <h3 className="mt-3 font-serif font-medium text-[#F9F1E2] text-2xl leading-tight pr-6">
              Exclusive Tarot &amp; Sri Vidhya batches
            </h3>
            <p className="mt-2 text-[#D8C3B8] text-sm leading-relaxed body-serif">
              Limited seats for the upcoming intimate batches. Reserve your place
              on the sacred path with Shreya.
            </p>
            <a
              href={waLink(
                "Namaste Shreya, I'm interested in the exclusive Tarot / Sri Vidhya batch enrolment. Please share the details."
              )}
              target="_blank"
              rel="noreferrer"
              data-testid="enrollment-popup-cta"
              onClick={dismiss}
              className="btn-gold mt-5 inline-flex w-full items-center justify-center rounded-full px-6 py-3.5 text-xs uppercase tracking-[0.2em] font-semibold"
            >
              Enquire About a Seat
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
